import { render, staticRenderFns } from "./flat-modal.vue?vue&type=template&id=7574694c&scoped=true&"
import script from "./flat-modal.vue?vue&type=script&lang=js&"
export * from "./flat-modal.vue?vue&type=script&lang=js&"
import style0 from "./flat-modal.vue?vue&type=style&index=0&id=7574694c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7574694c",
  null
  
)

export default component.exports